module.exports = __webpack_public_path__ + "static/media/hamburger.cd325bbd.svg";